import { BridgesGameModel } from './bridges-game.model';

export class InitBridgesGame {
  static readonly type = '[BridgesGame] Init';
  constructor(public payload: BridgesGameModel) {}
}

export class PersistBridgesState {
  static readonly type = '[BridgesGame] Persist game state';
  constructor(public payload: BridgesGameModel) {}
}
